import { NUMERIRIVISTE, SLUG, ARTICOLI } from 'utils/endpoint'
import React, { useEffect, useState } from 'react'
import Error from 'next/error'
import MetaSeo from 'components/atomic/MetaSeo'
import { api, getBoxAbbonamento, getDiscipline, getTemi, ARTICOLO, LEZIONE } from 'utils'
import NumeroRivistaTemplate from 'react-components/templates/NumeroRivistaTemplate/NumeroRivistaTemplate'
import { useSelector, useDispatch } from 'react-redux'
import { sendProductDetailGTM } from 'utils/gtm'
import { setItem } from 'containers/toolbar'

const NumeroRivistaDetail = ({ item, page, statusCode, numeri, articoli, lezioni }) => {
  if (!item) return <Error statusCode={statusCode} />

  const { utente } = useSelector(state => state.utente)

  const dispatch = useDispatch()

  const [numeroRivista, setNumeroRivista] = useState(item)
  const [tassonomie, setTassonomie] = useState([])
  const [boxAbbonamento, setBoxAbbonamento] = useState([])

  const refresh = async () => {
    const response = await api.get(`${NUMERIRIVISTE}${numeroRivista.id}/`)
    setNumeroRivista(response.data)
    dispatch(setItem(response.data))
    sendProductDetailGTM(response.data.rivista, 'navigazione_standard')
  }

  useEffect(() => {
    refresh()
    initTassonomie()
  }, [])

  useEffect(() => {
    initBoxAbbonamento()
  }, [utente])

  function initTassonomie() {
    setTassonomie(
      getDiscipline(numeroRivista.tassonomia, true).concat(getTemi(numeroRivista.tassonomia, true))
    )
  }

  function initBoxAbbonamento() {
    setBoxAbbonamento(getBoxAbbonamento(numeroRivista.rivista.box_abbonamenti, utente))
  }

  const props = {
    numeroRivista,
    numeri,
    tassonomie,
    articoli,
    lezioni,
    boxAbbonamento,
    page,
  }

  return (
    <>
      <MetaSeo seo={page.seo} />
      <NumeroRivistaTemplate {...props} />
    </>
  )
}

// export async function getStaticPaths() {
//   const response = await api.get(NUMERIRIVISTE)
//   const numeri = response.data.results

//   const paths = numeri
//     .map(n => {
//       const slugRivista = n.url.split('/')[2]
//       return { params: { slug: slugRivista, numero: n.slug } }
//     })
//     .slice(0, 5)

//   return {
//     paths,
//     fallback: 'blocking',
//   }
// }

// export const getStaticProps = async ({ params: { numero }, res, req }) => {
export const getServerSideProps = async ({ query: { numero }, res, req }) => {
  const headers = req?.headers?.cookie
    ? { cookie: req.headers.cookie, anteprima: req.headers.anteprima || false }
    : undefined

  try {
    const response = await api.get(`${NUMERIRIVISTE}${SLUG}${numero}/`, { headers })
    const numeroRivista = response.data

    const page = numeroRivista.pagina

    const toolbarProps = { toolbarItem: numeroRivista, toolbarPage: page }

    let params = {
      page_size: 4,
      page: 1,
      rivista_id: numeroRivista.rivista.id,
    }
    const numeriResponse = await api.get(NUMERIRIVISTE, { params })
    const numeri = numeriResponse.data.results

    params = {
      in_numero_rivista: true,
      numero_rivista_id: numeroRivista.id,
    }
    const responseArticoli = await api.get(ARTICOLI, { params })
    const risorse = responseArticoli.data.results
    const articoli = risorse.filter(item => item.tipologia === ARTICOLO)
    const lezioni = risorse.filter(item => item.tipologia === LEZIONE)

    return {
      props: {
        item: numeroRivista,
        page,
        key: numeroRivista.id,
        ...toolbarProps,
        numeri,
        articoli,
        lezioni,
      },
      // revalidate: 60 * 2,
    }
  } catch (error) {
    if (res) {
      res.statusCode = 404
    }
    return { props: { statusCode: 404 } }
  }
}

export default NumeroRivistaDetail
